module.exports = __webpack_public_path__ + "static/img/choose-esthetician-01.98a8d2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/choose-esthetician-01.jpg
// module id = 253
// module chunks = 1